module.exports = __webpack_public_path__ + "static/media/info_purple.50b4df6d.svg";